import { render, staticRenderFns } from "./SaveDutyPlanChangesMenue.vue?vue&type=template&id=154986a4&scoped=true&"
import script from "./SaveDutyPlanChangesMenue.vue?vue&type=script&lang=js&"
export * from "./SaveDutyPlanChangesMenue.vue?vue&type=script&lang=js&"
import style0 from "./SaveDutyPlanChangesMenue.vue?vue&type=style&index=0&id=154986a4&scoped=true&lang=css&"
import style1 from "./SaveDutyPlanChangesMenue.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154986a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDivider,VIcon,VMenu,VSpacer})
